// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_Xp4n3I","popper":"ob_N1C5dt","option":"ob_BwmJM9","prefixNote":"ob_nVCTQT"};